"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _tooltip = require("@nivo/tooltip");

var _pie = require("@nivo/pie");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function DrawRadialGaugeLayer(_ref) {
  var id = _ref.id,
      data = _ref.data,
      value = _ref.value,
      valueFormat = _ref.valueFormat,
      colors = _ref.colors,
      innerRadius = _ref.innerRadius,
      startAngle = _ref.startAngle,
      endAngle = _ref.endAngle,
      padAngle = _ref.padAngle,
      sortByValue = _ref.sortByValue,
      cornerRadius = _ref.cornerRadius,
      _ref$isInteractive = _ref.isInteractive,
      isInteractive = _ref$isInteractive === void 0 ? true : _ref$isInteractive,
      radius = _ref.radius,
      showTooltip = _ref.showTooltip,
      _ref$onMouseEnter = _ref.onMouseEnter,
      onMouseEnter = _ref$onMouseEnter === void 0 ? function (event) {
    return event;
  } : _ref$onMouseEnter,
      _ref$onMouseLeave = _ref.onMouseLeave,
      onMouseLeave = _ref$onMouseLeave === void 0 ? function (event) {
    return event;
  } : _ref$onMouseLeave;

  var _useTooltip = (0, _tooltip.useTooltip)(),
      showTooltipFromEvent = _useTooltip.showTooltipFromEvent,
      hideTooltip = _useTooltip.hideTooltip;

  var normalizedData = (0, _pie.useNormalizedData)({
    data: data,
    id: id,
    value: value,
    valueFormat: valueFormat,
    colors: colors
  });

  var _usePie = (0, _pie.usePie)({
    data: normalizedData,
    innerRadius: innerRadius,
    radius: radius,
    startAngle: startAngle,
    endAngle: endAngle,
    padAngle: padAngle,
    sortByValue: sortByValue,
    cornerRadius: cornerRadius
  }),
      dataWithArc = _usePie.dataWithArc,
      arcGenerator = _usePie.arcGenerator;

  var PieTooltip = function PieTooltip(_ref2) {
    var datum = _ref2.datum;
    return (0, _jsxRuntime.jsx)(_tooltip.BasicTooltip, {
      id: datum.id,
      value: datum.formattedValue,
      enableChip: true,
      color: datum.color
    });
  };

  var handleMouseEnter = (0, _react.useMemo)(function () {
    if (!isInteractive) return undefined;
    return function (event) {
      if (showTooltip) {
        showTooltipFromEvent((0, _jsxRuntime.jsx)(PieTooltip, {
          datum: dataWithArc[0]
        }), event);
      }

      onMouseEnter(dataWithArc[0]);
    };
  }, [isInteractive, showTooltipFromEvent, dataWithArc, showTooltip, onMouseEnter]);
  var handleMouseMove = (0, _react.useMemo)(function () {
    if (!isInteractive) return undefined;
    return function (event) {
      if (showTooltip) {
        showTooltipFromEvent((0, _jsxRuntime.jsx)(PieTooltip, {
          datum: dataWithArc[0]
        }), event);
      }
    };
  }, [isInteractive, showTooltipFromEvent, dataWithArc, showTooltip]);
  var handleMouseLeave = (0, _react.useMemo)(function () {
    if (!isInteractive) return undefined;
    return function (event) {
      if (showTooltip) {
        hideTooltip();
      }

      onMouseLeave(event);
    };
  }, [isInteractive, hideTooltip, showTooltip, onMouseLeave]);
  return (0, _jsxRuntime.jsx)("path", {
    d: arcGenerator(_objectSpread({}, dataWithArc[0].arc)),
    fill: dataWithArc[0].color,
    onMouseEnter: handleMouseEnter,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave
  });
}

var _default = DrawRadialGaugeLayer;
exports["default"] = _default;